var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExtendedWarrenty(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 83.029,
    height: 83.001,
    viewBox: "0 0 83.029 83.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "extended_warrenty",
    transform: "translate(-2.002 -2.034)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8473",
    "data-name": "Path 8473",
    d: "M35.451,38.9A12.451,12.451,0,1,0,23,26.45,12.451,12.451,0,0,0,35.451,38.9Zm0-22.136a9.684,9.684,0,1,1-9.684,9.684,9.684,9.684,0,0,1,9.684-9.684Z",
    transform: "translate(8.053 4.59)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8474",
    "data-name": "Path 8474",
    d: "M2.18,36.09a1.384,1.384,0,0,0,1.2.7H26.39l.06,3.11a1.381,1.381,0,0,0,.931,1.28L32.9,43.093l3.517,4.657a1.383,1.383,0,0,0,1.507.49l5.585-1.7,5.584,1.7a1.388,1.388,0,0,0,1.508-.49l3.518-4.657,5.515-1.909a1.383,1.383,0,0,0,.931-1.28l.059-3.111h23A1.383,1.383,0,0,0,84.811,34.7l-3.723-6.206,3.723-6.2a1.384,1.384,0,0,0-1.186-2.1h-23l-.061-3.113a1.381,1.381,0,0,0-.931-1.28l-5.515-1.909L50.6,9.232a1.384,1.384,0,0,0-1.507-.49l-5.584,1.7-5.584-1.7a1.386,1.386,0,0,0-1.507.49L32.9,13.889,27.381,15.8a1.383,1.383,0,0,0-.931,1.28l-.06,3.11H3.384A1.383,1.383,0,0,0,2.2,22.284L5.923,28.49,2.2,34.7a1.382,1.382,0,0,0-.02,1.39Zm79-13.133-2.89,4.821a1.384,1.384,0,0,0,0,1.424l2.893,4.823H60.7L64,29.281A1.384,1.384,0,0,0,64,27.7l-3.3-4.743ZM28.847,24.148a1.383,1.383,0,0,0,.248-.764l.1-5.289,5-1.731a1.386,1.386,0,0,0,.652-.473L38.04,11.67l5.06,1.543a1.381,1.381,0,0,0,.807,0l5.062-1.541,3.189,4.221a1.386,1.386,0,0,0,.652.473l5,1.731.1,5.289a1.373,1.373,0,0,0,.249.764l3.022,4.341-3.024,4.343a1.383,1.383,0,0,0-.248.764l-.1,5.289-5,1.731a1.386,1.386,0,0,0-.652.473l-3.189,4.221-5.062-1.543a1.425,1.425,0,0,0-.4-.059,1.442,1.442,0,0,0-.4.059L38.038,45.31,34.85,41.089a1.386,1.386,0,0,0-.652-.473l-5-1.731L29.1,33.6a1.373,1.373,0,0,0-.249-.764l-3.022-4.341ZM8.72,29.2a1.384,1.384,0,0,0,0-1.424L5.827,22.957H26.3L23,27.7a1.384,1.384,0,0,0,0,1.581l3.305,4.743H5.827Z",
    transform: "translate(0 2.55)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8475",
    "data-name": "Path 8475",
    d: "M32.422,29.93h.062a1.384,1.384,0,0,0,1-.5l6.917-8.3-2.125-1.77L32.329,26.5l-3.08-3.08-1.956,1.956,4.15,4.15a1.382,1.382,0,0,0,.979.4Z",
    transform: "translate(9.7 6.645)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8476",
    "data-name": "Path 8476",
    d: "M37.005,69.234c.03.717.059,1.41.079,2.072l2.766-.077c-.018-.674-.048-1.382-.08-2.111-.19-4.481-.427-10.057,1.976-13.438.014-.018.014-.018,5.037-7.115a1.209,1.209,0,0,1,.985-.511,1.194,1.194,0,0,1,1.028.573,1.158,1.158,0,0,1,.093,1.1l-2.963,5.126a4.15,4.15,0,0,0-.558,2.078h2.767a1.375,1.375,0,0,1,.185-.692l.293-.508,6.248-2.085.044.022.022-.044L58.7,52.367a4.162,4.162,0,0,0,1.693-1.184L66.722,43.8a1.232,1.232,0,0,1,1.846-.026A1.317,1.317,0,0,1,68.6,45.4l-7.7,11a4.236,4.236,0,0,1-.668.746L55,61.718c-1.823,1.6-6.038,5.71-5.772,9.422l2.76-.2c-.145-2.02,2.512-5.109,4.834-7.14l5.228-4.575a6.985,6.985,0,0,0,1.112-1.24l7.7-11A4,4,0,0,0,64.621,42l-.411.479.094-.566a3.5,3.5,0,0,0-6.848-1.425l-.945,3.784-3.549,7.1L50.7,52.12l.623-1.079a3.974,3.974,0,0,0-6.8-4.074l-5.012,7.082c-2.972,4.182-2.713,10.283-2.5,15.185Zm22.05-23.867a1.369,1.369,0,0,0,.105-.284l.982-3.93a.734.734,0,0,1,1.435.3l-.847,5.084L58.291,49.38a1.342,1.342,0,0,1-.517.378l-1.1.365Z",
    transform: "translate(13.38 13.729)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8477",
    "data-name": "Path 8477",
    d: "M25.9,48.055a1.209,1.209,0,0,1,.986.511L31.9,55.652c2.424,3.412,2.187,8.989,2,13.468-.03.729-.061,1.436-.079,2.11l2.766.077c.018-.661.048-1.354.079-2.07.208-4.9.466-11-2.507-15.189h0c-.268-.392-1.238-1.76-5.007-7.086a3.974,3.974,0,0,0-6.761,4.148l.581,1L20.7,51.363l-3.549-7.1-.946-3.784A3.5,3.5,0,0,0,9.358,41.9l.094.566-.411-.477A4.012,4.012,0,0,0,6.1,40.6a4.14,4.14,0,0,0-3.019,1.266A4.07,4.07,0,0,0,2.8,46.984l7.7,11a6.961,6.961,0,0,0,1.111,1.24L16.839,63.8c2.32,2.031,4.979,5.119,4.834,7.14l2.76.2c.266-3.712-3.947-7.825-5.771-9.422L13.435,57.14a4.2,4.2,0,0,1-.667-.743l-7.7-11A1.315,1.315,0,0,1,5.1,43.769a1.28,1.28,0,0,1,.942-.4,1.232,1.232,0,0,1,.9.429l6.331,7.385a4.2,4.2,0,0,0,1.742,1.2l3.723,1.242.022.043.043-.022,6.249,2.085.293.509a2.7,2.7,0,0,1,.185.96H28.3a5.236,5.236,0,0,0-.558-2.345L24.815,49.8A1.206,1.206,0,0,1,25.9,48.055Zm-9.958,1.721a1.388,1.388,0,0,1-.564-.4l-2.439-2.844-.847-5.084a.732.732,0,0,1,1.433-.3l.982,3.932a1.4,1.4,0,0,0,.1.284l2.38,4.758Z",
    transform: "translate(0.012 13.728)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8478",
    "data-name": "Path 8478",
    d: "M31.405,42.024c-.87-.066-1.749-.177-2.608-.329l-.481,2.725c.949.167,1.918.289,2.879.362Z",
    transform: "translate(10.092 15.21)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8479",
    "data-name": "Path 8479",
    d: "M35.069,41.847c-.865.107-1.747.17-2.619.19l.062,2.767c.964-.022,1.938-.093,2.9-.21Z",
    transform: "translate(11.677 15.269)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8480",
    "data-name": "Path 8480",
    d: "M27.785,41.505a26.188,26.188,0,0,1-2.489-.841l-1.014,2.575c.9.356,1.826.668,2.75.93Z",
    transform: "translate(8.545 14.815)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8481",
    "data-name": "Path 8481",
    d: "M36.212,41.719l.61,2.7a28.542,28.542,0,0,0,2.8-.784l-.881-2.623a25.994,25.994,0,0,1-2.529.707Z",
    transform: "translate(13.12 14.947)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8482",
    "data-name": "Path 8482",
    d: "M24.336,40.245c-.776-.4-1.54-.847-2.27-1.321l-1.509,2.319a28.633,28.633,0,0,0,2.51,1.46Z",
    transform: "translate(7.116 14.148)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8483",
    "data-name": "Path 8483",
    d: "M42.144,39.448c-.757.437-1.544.841-2.337,1.2l1.139,2.522c.877-.4,1.746-.843,2.582-1.325Z",
    transform: "translate(14.499 14.349)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8484",
    "data-name": "Path 8484",
    d: "M21.192,38.294c-.679-.546-1.341-1.134-1.963-1.746l-1.94,1.974a28.95,28.95,0,0,0,2.169,1.929Z",
    transform: "translate(5.863 13.236)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8485",
    "data-name": "Path 8485",
    d: "M45.144,37.232c-.654.578-1.345,1.129-2.053,1.639l1.617,2.245c.782-.563,1.545-1.172,2.269-1.811Z",
    transform: "translate(15.758 13.499)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8486",
    "data-name": "Path 8486",
    d: "M14.6,35.185a28.955,28.955,0,0,0,1.746,2.32l2.125-1.772c-.559-.671-1.09-1.377-1.58-2.1Z",
    transform: "translate(4.834 12.119)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8487",
    "data-name": "Path 8487",
    d: "M45.934,36.464l2.03,1.882c.657-.71,1.285-1.457,1.865-2.223l-2.2-1.671C47.1,35.144,46.53,35.822,45.934,36.464Z",
    transform: "translate(16.848 12.432)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8488",
    "data-name": "Path 8488",
    d: "M12.611,31.363c.374.894.794,1.774,1.252,2.62L16.3,32.668a26.027,26.027,0,0,1-1.132-2.37Z",
    transform: "translate(4.069 10.84)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8489",
    "data-name": "Path 8489",
    d: "M51.975,32.413l-2.493-1.2a25.941,25.941,0,0,1-1.255,2.308l2.36,1.443C51.088,34.143,51.556,33.284,51.975,32.413Z",
    transform: "translate(17.727 11.191)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8490",
    "data-name": "Path 8490",
    d: "M13.55,14.911l2.511,1.162a26.03,26.03,0,0,1,1.222-2.324L14.9,12.34c-.491.833-.945,1.7-1.35,2.571Z",
    transform: "translate(4.429 3.953)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8491",
    "data-name": "Path 8491",
    d: "M52.912,15.383c-.383-.883-.818-1.758-1.288-2.6l-2.416,1.349c.426.764.819,1.555,1.166,2.355Z",
    transform: "translate(18.104 4.122)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8492",
    "data-name": "Path 8492",
    d: "M19.573,10.816,17.52,8.962a28.8,28.8,0,0,0-1.835,2.251l2.229,1.639a26.236,26.236,0,0,1,1.659-2.036Z",
    transform: "translate(5.248 2.658)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8493",
    "data-name": "Path 8493",
    d: "M50.913,11.639c-.551-.789-1.15-1.561-1.778-2.294l-2.1,1.8c.57.664,1.111,1.363,1.61,2.077Z",
    transform: "translate(17.27 2.804)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8494",
    "data-name": "Path 8494",
    d: "M20.351,10.035c.646-.587,1.33-1.148,2.031-1.668L20.735,6.143c-.775.574-1.529,1.194-2.243,1.843Z",
    transform: "translate(6.324 1.577)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8495",
    "data-name": "Path 8495",
    d: "M44.291,8.631a26.226,26.226,0,0,1,1.988,1.717l1.911-2c-.7-.668-1.439-1.306-2.2-1.9Z",
    transform: "translate(16.218 1.695)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8496",
    "data-name": "Path 8496",
    d: "M25.6,6.5,24.424,4a28.764,28.764,0,0,0-2.562,1.363l1.419,2.375A26.206,26.206,0,0,1,25.6,6.5Z",
    transform: "translate(7.616 0.752)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8497",
    "data-name": "Path 8497",
    d: "M41.084,6.691a26.178,26.178,0,0,1,2.287,1.287l1.476-2.339c-.818-.516-1.668-.995-2.53-1.425Z",
    transform: "translate(14.988 0.836)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8498",
    "data-name": "Path 8498",
    d: "M26.573,6.037c.819-.288,1.667-.538,2.517-.744L28.439,2.6a29.008,29.008,0,0,0-2.785.823Z",
    transform: "translate(9.071 0.219)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8499",
    "data-name": "Path 8499",
    d: "M41.016,3.62a28.966,28.966,0,0,0-2.766-.89L37.538,5.4a25.577,25.577,0,0,1,2.5.8Z",
    transform: "translate(13.628 0.268)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8500",
    "data-name": "Path 8500",
    d: "M30.108,5.024A26.165,26.165,0,0,1,32.724,4.8l-.1-2.766c-.966.036-1.94.12-2.893.252Z",
    transform: "translate(10.634)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8501",
    "data-name": "Path 8501",
    d: "M33.792,4.819c.877.055,1.757.152,2.613.292l.441-2.731c-.945-.154-1.916-.261-2.883-.322Z",
    transform: "translate(12.192 0.01)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExtendedWarrenty);
export default __webpack_public_path__ + "static/media/extended_warrenty.9e348af77ecb3b4d6152b2ca0d198f55.svg";
export { ForwardRef as ReactComponent };